//window.Sortable = require('../../../node_modules/sortablejs/Sortable.js');  
window.Sortable = require('./components/Sortable.js');  
require('./components/angular-local-storage.js');

require('./scripts/adf-structures-base.js');
require('./scripts/angular-dashboard-framework.js'); 